var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDrop = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21895 0.113724C5.02949 -0.0378024 4.76032 -0.0379085 4.57066 0.11341C4.39575 0.252776 0.289062 3.56785 0.289062 7.07373C0.289062 9.97423 2.18293 11.9999 4.89449 11.9999C7.68348 11.9999 9.70778 9.92798 9.70778 7.07373C9.70788 3.73953 5.40228 0.260365 5.21895 0.113724ZM5.522 10.6954C5.47898 10.7062 5.43585 10.7115 5.39345 10.7115C5.16159 10.7115 4.95009 10.555 4.89023 10.3198C4.81956 10.0421 4.98699 9.75973 5.26437 9.68843C5.35946 9.66339 7.43811 9.09044 7.4378 7.00472C7.4378 6.71767 7.67028 6.48508 7.95733 6.48498C8.24438 6.48498 8.47707 6.71757 8.47707 7.00451C8.47749 9.32895 6.54413 10.4352 5.522 10.6954Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDrop, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/drop.033eb04f.svg";
export { ForwardRef as ReactComponent };